module.exports = __webpack_public_path__ + "assets/img/dapnet-logo.1b696f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dapnet-logo.png
// module id = 4QwZ
// module chunks = 1